module.exports = {
	"pagination": {
		"ListBranches": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "branches"
		},
		"ListRepositories": {
			"input_token": "nextToken",
			"output_token": "nextToken",
			"result_key": "repositories"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/codecommit-2015-04-13.paginators.json
// module id = 561
// module chunks = 0 1 2 3 4 6 7 8